import http from '@/lib/http';

export default {
    createJsapiSignature() {
        return http({
            url: `/wxService/createJsapiSignature?url=${window.location.href.split("#")[0]}`
        });
    },
    createPaySignature(prepayId) {
        return http({
            url: `/wxService/createPaySignature/${prepayId}`
        });
    }
}